import React from 'react';
import { Container } from '@hpi-sox/hpstellar-core/visId';

import ConfigureOptions from '../components/configure-options';
import RecommendedConfigurations from '../components/recommended-configurations';

import CurrentConfig from './current-config';
import ConfigureStickyHeader from './sticky-header';
import ConfigureTitle from './configure-title';
import PriceAtc from './price-atc/price-atc';
import useAddCTOToCart from '../components/sticky-header/useAddCTOToCart';
import ConsumerFinanceWidget from '../../product/components/consumer-finance-widget';
import withPageComponents from '../../page/components/with-page-components';
import { useMSRPProps } from '../../hooks/useProductPrice';

import './configure.less';

const Configure = ({ toggleCompare, trackCustomMetric, ctoProductInitial, shipDate }) => {
    const { buttonProps, price } = useAddCTOToCart(trackCustomMetric, { endIcon: false });
    const msrp = useMSRPProps({ position: 'top-start' });
    const { days } = shipDate || {};

    return (
        <>
            <ConfigureStickyHeader />
            <section id="configureOptions">
                <Container className="configure-v2-container">
                    <div className="configure-v2-specs">
                        <ConfigureTitle />
                        <RecommendedConfigurations toggleCompare={toggleCompare} v2 />
                        <ConfigureOptions v2 />
                    </div>

                    <CurrentConfig />
                    <div className="configure-v2-price-atc-footer">
                        {days < 31 ? <ConsumerFinanceWidget price={price} product={ctoProductInitial} /> : null}
                        <PriceAtc
                            className="configure-v2-price-atc"
                            price={price}
                            buttonProps={buttonProps}
                            msrp={msrp}
                            showLabel={false}
                            loaderEnabled={true}
                        />
                    </div>
                </Container>
            </section>
        </>
    );
};

export default withPageComponents(Configure, {
    components: ['shipDate', 'ctoProductInitial'],
});
